
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericClosedLeft as ObiThreewayAcuatorGenericClosedLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-closed-left.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericClosedLeft = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-closed-left',
   elementClass: ObiThreewayAcuatorGenericClosedLeftElement,
   events: {
     
   }
  });
 
 